var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarIcon = function SvgStarIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 12.8023L4.09394 14.8184C3.22744 15.2656 2.65957 14.8579 2.82465 13.913L3.57065 9.64283L0.410548 6.61866C-0.290458 5.94781 -0.0710195 5.29161 0.895372 5.15374L5.26252 4.53073L7.21557 0.645589C7.64882 -0.216253 8.35231 -0.214139 8.7845 0.645589L10.7375 4.53073L15.1047 5.15374C16.0735 5.29195 16.2888 5.94946 15.5895 6.61866L12.4294 9.64283L13.1754 13.913C13.3409 14.8603 12.7705 15.2645 11.9061 14.8184L8.00004 12.8023Z",
    fill: "#F1C118"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-icon.d57380b4.svg";
export { ForwardRef as ReactComponent };